import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Table } from '../../../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { valToPercent } from '../../../../../../helpers/value'
import { SORT_DIRECTION } from '../../../../../../utils/common'
import CustomValue from '../../CustomValue'
import { HeaderTable } from '../../HeaderTable'
import { getHeadersFollowColumn } from '../../helpers'
import {
  selectIsLoadingReal,
  selectRealHeaders,
  selectRealIds,
  selectRealItem,
  selectSortTable,
  sortReal,
} from '../store/slice'

export const TableRealGDP = ({ isDynamicReport, column }) => {
  const dispatch = useDispatch()
  const { formatCurrency } = useFormatCurrency(SCREEN.INDUSTRY_OVERVIEW)

  const ids = useSelector(selectRealIds)
  const isLoading = useSelector(selectIsLoadingReal)
  const headers = useSelector(selectRealHeaders)
  const sortTable = useSelector(selectSortTable)

  const customHeaders = isDynamicReport
    ? getHeadersFollowColumn(headers, column)
    : headers

  const changeSort = (data) => {
    dispatch(sortReal(data))
  }

  useEffect(() => {
    if (ids.length && !!headers.length) {
      dispatch(
        sortReal({
          sortBy: [...headers].reverse()[0].childCol[0].colId,
          sortDirection: SORT_DIRECTION.DESC,
        }),
      )
    }
  }, [ids.length])

  return (
    <Table
      ids={ids}
      isLoading={isLoading}
      isNoDataWithHead={!isDynamicReport}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isStickyFirstCol={!isDynamicReport}
      isDynamicReport={isDynamicReport}
      getDataFromRedux={selectRealItem}
      renderTHead={() => (
        <HeaderTable
          isDynamicReport={isDynamicReport}
          headerTable={customHeaders}
          sort={sortTable}
          changeSort={changeSort}
        />
      )}
      schema={customHeaders
        .map((item, index) => {
          const result = {
            ...item,
          }

          if (index === 0) {
            return {
              ...result,
              render: (val) => {
                return isDynamicReport ? (
                  val
                ) : (
                  <TextEllipsisStaticLine
                    isI18n={false}
                    text={val}
                    lineClamp={2}
                    appendStyle={{ width: 350 }}
                  />
                )
              },
            }
          }

          if (item.childCol) {
            return item.childCol.map((childItem) => {
              const [year, type] = childItem.colId.split('-')

              if (type === 'contribution') {
                return {
                  ...childItem,
                  render: (val) => {
                    return <CustomValue val={val} />
                  },
                }
              }

              if (type === 'growthRate') {
                return {
                  ...childItem,
                  render: (val, { locale }) => {
                    return valToPercent(val, locale)
                  },
                }
              }

              return {
                ...childItem,
                render: (value) => {
                  return formatCurrency({
                    value,
                    year,
                    exchangeRateType: 'averageRate',
                  })
                },
              }
            })
          }

          return result
        })
        .flat()}
    />
  )
}
